var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllAreas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83463 2.3229C9.8067 2.67189 11.3586 4.23762 11.687 6.21672H12.5013L12.5785 6.22062C12.9564 6.25924 13.2513 6.57855 13.2513 6.96672C13.2513 7.35488 12.9564 7.67419 12.5785 7.71281L12.5013 7.71672H11.6976C11.3933 9.72724 9.82879 11.3243 7.83463 11.6772V12.3834L7.83073 12.4605C7.79211 12.8385 7.4728 13.1334 7.08463 13.1334C6.69647 13.1334 6.37716 12.8385 6.33854 12.4605L6.33463 12.3834V11.7036C4.26145 11.4124 2.6177 9.78293 2.30501 7.71672H1.66797C1.25376 7.71672 0.917969 7.38093 0.917969 6.96672C0.917969 6.5525 1.25376 6.21672 1.66797 6.21672H2.31559C2.65318 4.18219 4.28379 2.58451 6.33463 2.29646V1.55005C6.33463 1.13584 6.67042 0.800049 7.08463 0.800049C7.49885 0.800049 7.83463 1.13584 7.83463 1.55005V2.3229ZM7.0013 3.75004C8.79623 3.75004 10.2513 5.20512 10.2513 7.00004C10.2513 8.79497 8.79623 10.25 7.0013 10.25C5.20638 10.25 3.7513 8.79497 3.7513 7.00004C3.7513 5.20512 5.20638 3.75004 7.0013 3.75004ZM7.0013 9.00004C8.10587 9.00004 9.0013 8.10461 9.0013 7.00004C9.0013 5.89547 8.10587 5.00004 7.0013 5.00004C5.89673 5.00004 5.0013 5.89547 5.0013 7.00004C5.0013 8.10461 5.89673 9.00004 7.0013 9.00004Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAreas);
export default __webpack_public_path__ + "static/media/AllAreas.197fc4ca2f23c1d764c880a90777f007.svg";
export { ForwardRef as ReactComponent };